import { render, staticRenderFns } from "./CreateSecondSellerModal.vue?vue&type=template&id=5f5871d0&"
import script from "./CreateSecondSellerModal.vue?vue&type=script&lang=js&"
export * from "./CreateSecondSellerModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSecondSellerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports